export const state = () => ({
  activeIndex: 0,

  images: [],

  isOpenSwiperPopup: false,
})

export const mutations = {
  openSwiperPopup: function (state, {
    images,
    activeIndex
  }) {
    state.activeIndex = activeIndex || 0;
    state.images = images;
    state.isOpenSwiperPopup = true;
  },
  closeSwiperPopup: function (state) {
    state.isOpenSwiperPopup = false;
    state.images = [];
  },
}
